var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-text-field',{attrs:{"rules":_vm.minMaxRules,"type":"number","label":"Level Number"},model:{value:(_vm.object.level),callback:function ($$v) {_vm.$set(_vm.object, "level", _vm._n($$v))},expression:"object.level"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }